import { State, toODataString } from "@progress/kendo-data-query";
import axios from "axios";
import { CreateQueryString, KendoFilter, updatedCreateQueryString } from "../../ReusableComponents";

class ReportServices {
    getVendorPerformanceReportForExcel = (clientId, vendorId, dataState) => {
        var finalState: State = {
            ...dataState,
            take: null,
            skip: 0,
          };
        let finalQueryString = CreateQueryString(finalState, clientId, vendorId);  
        return axios.get(`api/report/vp?${finalQueryString}`)
    };

    getTimesheetReportForExcel = (clientId, vendorId, dataState,displayEntityNumber) => {
        var finalState: State = {
            ...dataState,
            take: null,
            skip: 0,
        };
        const additionalParams = `&displayEntityNumber=${encodeURIComponent(displayEntityNumber)}`;
        let finalQueryString = CreateQueryString(finalState, clientId, vendorId);  
        return axios.get(`/api/grid/tsexcel?${finalQueryString}${additionalParams}`)
    };

    getFilledAssignmentReportForExcel = (clientId, vendorId, dataState) => {
      var finalState: State = {
          ...dataState,
          take: null,
          skip: 0,
        };
      let finalQueryString = CreateQueryString(finalState, clientId, vendorId);  
      return axios.get(`/api/grid/faexcel?${finalQueryString}`)
    };

    getClientActivityReportForExcel = (clientId, vendorId, dataState, displayEntityNumber) => {
        var finalState: State = {
            ...dataState,
            take: null,
            skip: 0,
        };
        const additionalParams = `&displayEntityNumber=${encodeURIComponent(displayEntityNumber)}`;

        let finalQueryString = CreateQueryString(finalState, clientId, vendorId);
        return axios.get(`/api/grid/caexcel?${finalQueryString}${additionalParams}`)
    };
    getCandidateSubmissionAttemptsReportForExcel = (clientId, vendorId, dataState, displayEntityNumber) => {
      var finalState: State = {
          ...dataState,
          take: null,
          skip: 0,
        };
        const additionalParams = `&displayEntityNumber=${encodeURIComponent(displayEntityNumber)}`;

      let finalQueryString = CreateQueryString(finalState, clientId, vendorId);
        return axios.get(`/api/grid/csaexcel?${finalQueryString}${additionalParams}`)
  };

    getRequisitionFunnelReportExcelForExcel = (clientId, vendorId, dataState, displayEntityNumber) => {
      var finalState: State = {
          ...dataState,
          take: null,
          skip: 0,
        };
        const additionalParams = `&displayEntityNumber=${encodeURIComponent(displayEntityNumber)}`;

      let finalQueryString = CreateQueryString(finalState, clientId, vendorId);
        return axios.get(`/api/grid/rfexcel?${finalQueryString}${additionalParams}`)
  };

  getClientRateCardExcel = (clientId, dataState, date) => {
    var todaysDate = date.toISOString().substring(0, 10);
    var finalState: State = {
        ...dataState,
        take: null,
        skip: 0,
    };
    var queryStr = `${toODataString(finalState)}`;
    let queryParams = `clientId eq ${clientId} and (validTo ge ${todaysDate} or validTo eq null)`;
    var finalQueryString = KendoFilter(dataState, queryStr, queryParams);
    return axios.get(`/api/grid/rate/excel?${finalQueryString}`)
  };

  getcbiReportExcelForExcel = (clientId, vendorId, dataState, 
    billingPeriodStartDate, billingPeriodEndDate, extractType) => {
    var finalState: State = {
        ...dataState,
        take: null,
        skip: 0,
    };
    let finalQueryString = CreateQueryString(finalState, clientId, vendorId);
    return axios.get(`/api/grid/cbiexcel?billingPeriodEndDate=${billingPeriodEndDate}&billingPeriodStartDate=${billingPeriodStartDate}&extractType=${extractType}`)
  };

  getCandidateSubmittalReport = (dataState, clientId, vendorId) => {
    let finalQueryString = CreateQueryString(dataState, clientId, vendorId);
    return axios.get(`api/report/cs?${`$count=true&`}&${finalQueryString}`)
  };

  getCandidateSubmittalReportForExcel = (clientId, vendorId, dataState) => {
    let finalQueryString = CreateQueryString(dataState, clientId, vendorId);
    return axios.get(`/api/report/csexcel?${finalQueryString}`)
  };

  getExpiringCredentialReport = (dataState, clientId, vendorId) => {
    let finalQueryString = CreateQueryString(dataState, clientId, vendorId);
    return axios.get(`api/report/ec?${`$count=true&`}&${finalQueryString}`)
  };

  getExpiringCredentialReportForExcel = (clientId, vendorId, dataState) => {
    let finalQueryString = CreateQueryString(dataState, clientId, vendorId);
    return axios.get(`/api/report/ecexcel?${finalQueryString}`)
  };
}

export default new ReportServices();